<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-11 17:20:50
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-02-11 10:06:40
 * @FilePath: \sns-user-frontend\src\components\like.vue
 * @Description: 喜欢按钮
-->
<template>
  <svg-icon 
    :class="status ? 'icon-like' : 'icon-unlike'" 
    :name="status ? 'icon-like' : 'icon-unlike'"
    @click.stop.prevent="onClickIcon"
    :style="{
      cursor: uid === props.uid ? 'default' : 'cursor'
    }"
  ></svg-icon>
</template>

<script setup>

import { ref, watch, getCurrentInstance } from 'vue'
import http from '@/service'
import { $throttle } from '@/utils/lodashFuncs'
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';

const userStore = useUserStore()
const { uid } = storeToRefs(userStore)
const route = useRoute()
const { proxy } = getCurrentInstance()
const emit = defineEmits(['update:status', 'update:count'])
const props = defineProps({
  status: {
    type: Boolean,
    default: false
  },
  count: {
    type: Number,
    default: 0
  },
  id: {
    type: String,
    default: ''
  },
  uid: {
    type: String,
    default: ''
  },
  tid: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'thread'
  }
})

const status = ref(props.status)  // 点赞状态
const count = ref(props.count)  // 点赞数量

watch(() => props, ({ status: newStatus, count: newCount, uid}) => {
  status.value = newStatus
  count.value = newCount
}, { immediate: true, deep: true })

// 点赞
const onClickIcon = $throttle(async () => {
  proxy.$ga(status.value ? 'thread_cancel_thumbs_up' : 'thread_thumbs_up', {
    "screen_name": route.name,
    "thread_id": props.id,
  })
  // if (uid.value === props.uid) return
  const params = {
    id: props.id
  }
  if (props.type === 'comment') {
    params.tid = props.tid
  }
  const apiName = status.value ? 'unlike' : 'like'
  const { code, msg, data } = await http[apiName](params, props.type)
  if (code === 200) {
    let updateCount = count.value
    if (status.value) {
      updateCount--
    } else {
      updateCount++
    }
    status.value = !status.value
    emit('update:status', status.value)
    emit('update:count', updateCount)
    proxy.$toast({
      message: `${proxy.$t(apiName)} ${proxy.$t('success')}`
    })
  }
}, 2000) 

// 暴露点赞方法
defineExpose({
  onClickIcon
})
</script>

<style lang="postcss" scoped>
.icon-unlike {
}
.icon-like {
  color: #DF3D3D !important;
}
.svg-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
  color: var(--text-secondary);
}
</style>